import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade modal-lg-fullscreen-fix",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-focus": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px modal-fullscreen-lg-down" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header justify-content-start",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left fs-2x" })
  ])
], -1)
const _hoisted_6 = { class: "ms-2" }
const _hoisted_7 = { class: "modal-body p-5 px-lg-17" }
const _hoisted_8 = { class: "pb-5" }
const _hoisted_9 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_10 = { class: "form-floating mb-5" }
const _hoisted_11 = {
  disabled: "",
  value: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-label mb-3 required" }
const _hoisted_14 = { class: "form-floating mb-5" }
const _hoisted_15 = { class: "form-label mb-3 required" }
const _hoisted_16 = { class: "form-floating mb-5" }
const _hoisted_17 = { class: "form-label mb-3 required" }
const _hoisted_18 = { class: "input-group mb-5" }
const _hoisted_19 = { class: "form-floating flex-grow-1" }
const _hoisted_20 = { class: "form-label mb-3 required" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fs-2x" })
], -1)
const _hoisted_22 = { class: "pb-5" }
const _hoisted_23 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_24 = { class: "form-floating mb-5" }
const _hoisted_25 = {
  disabled: "",
  value: ""
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-label mb-3 required" }
const _hoisted_28 = {
  key: 0,
  class: "fv-row"
}
const _hoisted_29 = { class: "form-floating mb-5" }
const _hoisted_30 = {
  disabled: "",
  value: ""
}
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "form-label mb-3 required" }
const _hoisted_33 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_34 = { class: "form-floating mb-5" }
const _hoisted_35 = { class: "form-label mb-3 required" }
const _hoisted_36 = { class: "input-group mb-5" }
const _hoisted_37 = { class: "form-floating flex-grow-1" }
const _hoisted_38 = { class: "form-label mb-3 required" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-2x" })
], -1)
const _hoisted_40 = { class: "input-group mb-5" }
const _hoisted_41 = { class: "form-floating flex-grow-1" }
const _hoisted_42 = { class: "form-label mb-3 required" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fs-2x" })
], -1)
const _hoisted_44 = { class: "input-group mb-5" }
const _hoisted_45 = { class: "form-floating flex-grow-1" }
const _hoisted_46 = { class: "form-label mb-3 required" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fs-2x" })
], -1)
const _hoisted_48 = { class: "form-floating mb-5" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = { class: "form-label mb-3 required" }
const _hoisted_51 = { class: "pb-5" }
const _hoisted_52 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_53 = { class: "row col-11" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_58 = { class: "modal-footer" }
const _hoisted_59 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}
const _hoisted_60 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_FlatPickr = _resolveComponent("FlatPickr")!
  const _component_Combobox = _resolveComponent("Combobox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("menoresModalDatosMenorLabel")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                name: "tratamiento",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event)),
                class: "form-select form-select-solid"
              }, [
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("OpcionInicialTratamiento")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: tratamiento.id,
                    key: i
                  }, _toDisplayString(tratamiento.text), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.tratamiento]
              ]),
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("TratamientoLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "tratamiento",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                name: "nombre",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event)),
                type: "text",
                class: "form-control form-control-lg form-control-solid",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.nombre]
              ]),
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("menoresModalNombreLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "nombre",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                name: "apellidos",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event)),
                type: "text",
                class: "form-control form-control-lg form-control-solid",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.apellidos]
              ]),
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("menoresModalApellidosLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "apellidos",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FlatPickr, {
                  config: _ctx.configFechaNacimiento,
                  name: "fechaNacimiento",
                  modelValue: _ctx.fechaNacimiento,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: " ",
                  autocomplete: "off"
                }, null, 8, ["config", "modelValue"]),
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("menoresModalFechaNacimientoLabel")), 1)
              ]),
              _hoisted_21,
              _createVNode(_component_ErrorMessage, {
                name: "fechaNacimiento",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t("menoresModalDatosServicioLabel")), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("select", {
                name: "lugarPrestacion",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lugarPrestacion) = $event)),
                class: "form-select form-select-solid"
              }, [
                _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t("OpcionInicialLugarPrestacion")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lugaresPrestacion, (lugar, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: lugar.id,
                    key: i
                  }, _toDisplayString(lugar.nombre), 9, _hoisted_26))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.lugarPrestacion]
              ]),
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("lugarPrestacionMenorLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "lugarPrestacion",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            (_ctx.lugarPrestacion == 'ESPACIO')
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("select", {
                      name: "lugarEspacioColectivo",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lugarEspacioColectivo) = $event)),
                      class: "form-select form-select-solid"
                    }, [
                      _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("OpcionInicialLugarEspacioColectivo")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lugaresEspaciosColectivos, (lugarColectivo, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: lugarColectivo.id,
                          key: i
                        }, _toDisplayString(lugarColectivo.nombre), 9, _hoisted_31))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.lugarEspacioColectivo]
                    ]),
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("lugarEspacioColectivoMenorLabel")), 1),
                    _createVNode(_component_ErrorMessage, {
                      name: "lugarEspacioColectivo",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.lugarEspacioColectivo == 'OTROS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      name: "otrosEspacioColectivo",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otrosEspacioColectivo) = $event)),
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: " "
                    }, null, 512), [
                      [_vModelText, _ctx.otrosEspacioColectivo]
                    ]),
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("menoresModalOtrosEspacioColectivoLabel")), 1),
                    _createVNode(_component_ErrorMessage, {
                      name: "otrosEspacioColectivo",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  name: "direccion",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.direccion) = $event)),
                  type: "text",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: " "
                }, null, 512), [
                  [_vModelText, _ctx.direccion]
                ]),
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("menoresModalDireccionLabel")), 1)
              ]),
              _hoisted_39,
              _createVNode(_component_ErrorMessage, {
                name: "direccion",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_FlatPickr, {
                  config: _ctx.configInicioPrevisto,
                  name: "inicioPrevisto",
                  modelValue: _ctx.inicioPrevisto,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inicioPrevisto) = $event)),
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: " ",
                  autocomplete: "off",
                  onOnChange: _ctx.onStartChange
                }, null, 8, ["config", "modelValue", "onOnChange"]),
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("menoresModalInicioLabel")), 1)
              ]),
              _hoisted_43,
              _createVNode(_component_ErrorMessage, {
                name: "inicioPrevisto",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_FlatPickr, {
                  config: _ctx.configFinPrevisto,
                  name: "finPrevisto",
                  modelValue: _ctx.finPrevisto,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.finPrevisto) = $event)),
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: " ",
                  autocomplete: "off",
                  onOnChange: _ctx.onEndChange
                }, null, 8, ["config", "modelValue", "onOnChange"]),
                _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("menoresModalFinLabel")), 1)
              ]),
              _hoisted_47,
              _createVNode(_component_ErrorMessage, {
                name: "finPrevisto",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_48, [
              _withDirectives(_createElementVNode("textarea", {
                name: "detalleNecesidades",
                class: "form-control form-control-lg form-control-solid border-0 pe-10 resize-none min-h-100px",
                "data-kt-autosize": "true",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detalleNecesidades) = $event)),
                placeholder: _ctx.$t('placeholderDetalleNecesidades')
              }, null, 8, _hoisted_49), [
                [_vModelText, _ctx.detalleNecesidades]
              ]),
              _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("detalleNecesidades")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "detalleNecesidades",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("h2", _hoisted_52, _toDisplayString(_ctx.$t("menoresModalHorarioLabel")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiempos, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: i
              }, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_Combobox, {
                    class: "mb-5 col-12 col-md-6",
                    label: _ctx.$t('menoresModalDiasLabel'),
                    modelValue: item.dias,
                    "onUpdate:modelValue": ($event: any) => ((item.dias) = $event),
                    options: _ctx.dias,
                    settings: {
                    minimumResultsForSearch: Infinity,
                    selectionCssClass:
                      'form-control form-select form-select-solid',
                    multiple: true,
                    closeOnSelect: false,
                  }
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"]),
                  _createVNode(_component_Combobox, {
                    class: "mb-10 mb-md-5 col-12 col-md-6",
                    label: _ctx.$t('menoresModalHorasLabel'),
                    modelValue: item.horas,
                    "onUpdate:modelValue": ($event: any) => ((item.horas) = $event),
                    name: "martes",
                    options: _ctx.horarios,
                    settings: {
                    minimumResultsForSearch: Infinity,
                    selectionCssClass:
                      'form-control form-select form-select-solid',
                    multiple: true,
                    closeOnSelect: false,
                  }
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                  onClick: ($event: any) => (_ctx.removeInput(i))
                }, _hoisted_56, 8, _hoisted_54)
              ]))
            }), 128)),
            _createVNode(_component_ErrorMessage, {
              name: "tiempos",
              class: "fv-plugins-message-container invalid-feedback"
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addInput && _ctx.addInput(...args)))
            }, [
              _hoisted_57,
              _createTextVNode(_toDisplayString(_ctx.$t("menoresModalNuevoDia")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("button", _hoisted_59, [
              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("menoresModaleGuardarBtn")), 1)
            ], 512)
          ])
        ], 32)
      ])
    ])
  ], 512))
}